import './DebugPanel.sass'
import CollapsablePanel from '../../../common/CollapsablePanel/CollapsablePanel';
import Button from 'src/hci/common/Button/Button';
import {TbBolt, TbPlayerPauseFilled, TbPlayerPlayFilled, TbPlayerStopFilled } from 'react-icons/tb';
import useDeviceInfo from 'src/services/device/common/useDeviceInfo';
import { sendActivateRemoteDebugging, sendCancelReturnToHome, sendChargeClose, sendChargeOpen, sendCloseCover, sendClosePutter, sendDeactivateRemoteDebugging, sendOpenCover, sendOpenPutter, sendReboot, sendReturnHome, sendSetSilentMode, sendStopFlyto, sendSwitchBatteryStoreMode, sendTerminateMission, sendTurnOffDrone, sendTurnOnDrone } from 'src/services/device/common/remoteDebugUtils';

export default function DebugPanel({ entity, onClose, collapsed, missionController }) {
  const deviceInfo = useDeviceInfo(entity?.id);

  const handleClose = () => {
    onClose?.();
  }

  return (
    <div className="debug-panel">
      <CollapsablePanel title="Remote Debugging" collapsed={collapsed}>
        <div className="debug-actions">
          <Button onClick={() => sendActivateRemoteDebugging(entity?.id)}>
            <TbBolt className='icon' /> Start Debug
          </Button>
          <Button onClick={() => sendDeactivateRemoteDebugging(entity?.id)}>
            <TbBolt className='icon' /> Stop Debug
          </Button>
          <Button onClick={() => sendTurnOnDrone(entity?.id)}>
            <TbBolt className='icon' /> Turn on Drone
          </Button>
          <Button onClick={() => sendTurnOffDrone(entity?.id)}>
            <TbBolt className='icon' /> Turn off Drone
          </Button>
          <Button onClick={() => sendOpenCover(entity?.id)}>
            <TbBolt className='icon' /> Open Cover
          </Button>
          <Button onClick={() => sendCloseCover(entity?.id)}>
            <TbBolt className='icon' /> Close Cover
          </Button>
          <Button onClick={() => sendChargeOpen(entity?.id)}>
            <TbBolt className='icon' /> Force Start Charge
          </Button>
          <Button onClick={() => sendChargeClose(entity?.id)}>
            <TbBolt className='icon' /> Force Stop Charge
          </Button>
          <Button onClick={() => sendSwitchBatteryStoreMode(entity?.id, 2)}>
            <TbBolt className='icon' /> Battery Standby (~90%)
          </Button>
          <Button onClick={() => sendSwitchBatteryStoreMode(entity?.id, 1)}>
            <TbBolt className='icon' /> Battery Scheduled (~60%)
          </Button>
          <Button onClick={() => sendOpenPutter(entity?.id)}>
            <TbBolt className='icon' /> Open Putter
          </Button>
          <Button onClick={() => sendClosePutter(entity?.id)}>
            <TbBolt className='icon' /> Close Putter
          </Button>
          <Button onClick={() => sendSetSilentMode(entity?.id, 1)}>
            <TbBolt className='icon' /> Activate Silent Mode
          </Button>
          <Button onClick={() => sendSetSilentMode(entity?.id, 0)}>
            <TbBolt className='icon' /> Deactivate Silent Mode
          </Button>
          <Button onClick={() => sendReturnHome(entity?.id)}>
            <TbBolt className='icon' /> RTH
          </Button>
          <Button onClick={() => sendCancelReturnToHome(entity?.id)}>
            <TbBolt className='icon' /> RTH Cancel
          </Button>
          <Button onClick={() => missionController?.startDrc}>
            <TbBolt className='icon' /> Start DRC
          </Button>
          <Button onClick={() => missionController?.stopDrc}>
            <TbBolt className='icon' /> Stop DRC
          </Button>
          <Button onClick={() => missionController?.liveFlight?.sendFlightAuthorityGrab(deviceInfo?.id)}>
            <TbBolt className='icon' /> Get Flight Authority
          </Button>
          <Button onClick={() => sendStopFlyto(entity?.id)}>
            <TbBolt className='icon' /> Stop Flyto
          </Button>
          <Button onClick={() => sendTerminateMission(entity?.id)}>
            <TbBolt className='icon' /> Terminate Mission
          </Button>
          <Button onClick={() => sendReboot(entity?.id)}>
            <TbBolt className='icon' /> Reboot
          </Button>
        </div>
      </CollapsablePanel>
    </div>
  )
}
